<template>

  <div class="advertiser-container">
    <div>报告下载</div>

    <el-form inline :model="searchForm" label-width="140px" style="margin-top: 30px;">
      <el-row>
        <el-form-item label="填写日期">
          <el-date-picker
          v-model="searchForm.dateArray"
          type="daterange"
          range-separator="至"
          value-format="yyyy-M-d"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日">
        </el-date-picker>
      
      </el-form-item>
      <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出</el-button>
    </el-row>
  
      
    </el-form>

    </div>
</template>

<script>


import {getLatestMonthDateArrayByDate} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";

export default {
  name: "Advertiser",
  components: {}, 
  computed: { },
  data() {
    return {
     
      searchForm: {
        dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
      },
     
    };
  },
 

  async created() {
    
  },

  methods: {    

    async ExportList(){
      const [sDate, eDate] = this.searchForm.dateArray;
		  await this.$store.dispatch('operate/ExportReport', {            
			sDate:sDate,
		    eDate:eDate,
          
			});
    },


  },
};
</script>

<style scoped>

</style>